// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { arrayOf, object, func } from 'prop-types';
import CategoriesComponent from 'Components/Categories/Categories';

const Categories = ({ categories = [], selected = {}, onChange }) => {
  const [open, setOpen] = useState(true);
  const handleOnToggle = () => setOpen(!open);

  const handleOnClick = category => {
    onChange('category', category)(true, true);
  };

  return (
    <CategoriesComponent
      onClick={ handleOnClick }
      selected={ selected }
      open={ open }
      onToggle={ handleOnToggle }
      categories={ categories }
    />
  );
};

Categories.propTypes = {
  categories: arrayOf(object),
  onChange: func,
  selected: object,
};

export default Categories;
